import { mountProductAssistantWidget, type ProductAssistantWidgetHandle } from './mount';
import type { WidgetContainerProps } from '../components/WidgetContainer';

type WidgetRuntime = {
    mount: (target: HTMLElement, props?: WidgetContainerProps) => ProductAssistantWidgetHandle;
    open?: () => void;
    close?: () => void;
    dock?: () => void;
    undock?: () => void;
    send?: (message: string) => boolean;
};

declare global {
    interface Window {
        SKFProductAssistantWidget?: WidgetRuntime;
    }
}

const runtime: WidgetRuntime = window.SKFProductAssistantWidget ?? {
    mount(target: HTMLElement, props?: WidgetContainerProps) {
        return mountProductAssistantWidget(target, props);
    }
};

window.SKFProductAssistantWidget = runtime;

export {};
